export default function useChart() {
    const getLegendIcon = (type: "bar" | "line", color: string, disabled: boolean = false) => {
        const iconColor = (disabled ? "D9D9D9" : color).replace("#", "");

        switch (type) {
            case "bar":
                return `image://data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='4'%20y='4'%20width='8'%20height='8'%20fill='%23${iconColor}'/%3e%3c/svg%3e`;
            case "line":
                return `image://data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20y='7'%20width='16'%20height='2'%20fill='%23${iconColor}'/%3e%3cpath%20opacity='0.25'%20d='M4%204C6.20914%201.79086%209.79086%201.79086%2012%204C14.2091%206.20914%2014.2091%209.79086%2012%2012C9.79086%2014.2091%206.20914%2014.2091%204%2012C1.79086%209.79086%201.79086%206.20914%204%204Z'%20fill='%23${iconColor}'/%3e%3cpath%20d='M5.85352%205.85352C7.03897%204.66807%208.96103%204.66807%2010.1465%205.85352C11.3319%207.03897%2011.3319%208.96103%2010.1465%2010.1465C8.96103%2011.3319%207.03897%2011.3319%205.85352%2010.1465C4.66807%208.96103%204.66807%207.03897%205.85352%205.85352Z'%20fill='%23${iconColor}'%20stroke='white'/%3e%3c/svg%3e`;
        }
    };

    const getTooltipIcon = (type: "bar" | "line", color: string) => {
        switch (type) {
            case "bar":
                return `
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="4" y="4" width="8" height="8" fill="${color}"/>
                    </svg>
                    `;
            case "line":
                return `
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect y="7" width="16" height="2" fill="${color}"/>
                        <path opacity="0.25" d="M4 4C6.20914 1.79086 9.79086 1.79086 12 4C14.2091 6.20914 14.2091 9.79086 12 12C9.79086 14.2091 6.20914 14.2091 4 12C1.79086 9.79086 1.79086 6.20914 4 4Z" fill="${color}"/>
                        <path d="M5.85352 5.85352C7.03897 4.66807 8.96103 4.66807 10.1465 5.85352C11.3319 7.03897 11.3319 8.96103 10.1465 10.1465C8.96103 11.3319 7.03897 11.3319 5.85352 10.1465C4.66807 8.96103 4.66807 7.03897 5.85352 5.85352Z" fill="${color}" stroke="white"/>
                    </svg>
                    `;
        }
    };

    return {
        getLegendIcon,
        getTooltipIcon
    };
}
